import { AF_MEDICAL_QUESTION_ANSWERS, EPILEPSY_MEDICAL_QUESTION_ANSWERS, MEDICAL_QUESTION_ANSWERS } from "../consts";
export const renderMedicalQuestionAnswer = (condition, rawAnswer) => {
    if (!(condition && rawAnswer))
        return null;
    if (condition === 'A-Fib') {
        const ansNumber = rawAnswer.split('.').slice(-1)[0];
        return AF_MEDICAL_QUESTION_ANSWERS[ansNumber];
    }
    else if (condition === 'Epilepsy') {
        const ansNumber = rawAnswer.split('.').slice(-1)[0];
        return EPILEPSY_MEDICAL_QUESTION_ANSWERS[ansNumber];
    }
    else {
        const ansNumber = rawAnswer.split('.').slice(-1)[0];
        return MEDICAL_QUESTION_ANSWERS[ansNumber];
    }
};
export const capitalizeWords = (str) => {
    return str.split(' ').map((element) => {
        return element.charAt(0).toUpperCase() + element.substring(1).toLowerCase();
    }).join(' ');
};
export function timeZoneConvert(time, addOrLess) {
    const tzDifference = new Date().getTimezoneOffset() * -1;
    const offsetTime = (addOrLess === 'less') ? new Date(new Date(time).getTime() - (tzDifference * 60 * 1000)) : new Date(new Date(time).getTime() + (tzDifference * 60 * 1000));
    return offsetTime;
}
